
/**
 * Ellipse long words and sentences
 * @param {string} string text to be eclipsed.
 * @param {integer} displayAreaWidth current display area width
 * @param {integer} ellipsesPercentage 0-100, percentage of string not to wrap with respect to display area width
 * @return {string}
 */
 const autoEllipses = (string, displayAreaWidth, ellipsesPercentage = 60) => {
  let sliceLength =
    (parseInt(displayAreaWidth, 10) / 10) * (parseInt(ellipsesPercentage, 10) / 100);
  let suffix = sliceLength < string.length ? "..." : "";

  return string.slice(0, sliceLength) + suffix;
};


/**
 * Copies text to device clipboard
 *
 * @param {string} text
 * @returns {string}
 */
 const copyTextToClipboard = async (text) => {
  if ("clipboard" in navigator) {
    return await navigator.clipboard.writeText(text);
  } else {
    return document.execCommand("copy", true, text);
  }
};


const builderQueryParams = (params) => {
  const searchParams = new URLSearchParams();
  
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && value?.length !== 0) {
      if(Array.isArray(value)) {
        value.forEach((val) => {
          searchParams.append(key, String(val));
        });
      } else {
        searchParams.append(key, String(value));
      }
    }
  });

  return searchParams.toString();
}



export { autoEllipses, copyTextToClipboard, builderQueryParams };